import React from 'react';
import PasswordResetForm from 'components/layouts/authentication/PasswordResetForm';

const PasswordReset = () => (
  <div className="tw-text-center">
    <h5>Reset new password</h5>
    <PasswordResetForm />
  </div>
);

export default PasswordReset;
